// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__Vzn-w","head":"ProcedureTableInfo_head__uSwmw"};